<template>
  <v-container style="max-width:1200px" class="pa-0">
    <div class="text-left mb-2">
      <v-btn text color="primary" @click="$router.push('/manage/contracts')">
        <v-icon left text>arrow_left</v-icon>go back
      </v-btn>
      <span class="caption pa-1 lighten-1 primary white--text"> Manage cart scan route for contract {{contract.Name? contract.Name : "loading.."}}</span>
      <v-chip></v-chip>
    </div>
    <v-sheet class="pa-2 ma-2" align="center">
      <div class="pa-1" v-for="(node,i) in items" :key="i">
        <div>
          <node
            :node="node"
            :moveAction="hasEditPermission"
            :moveUp="i!=0"
            :moveDown="i!=items.length-1"
            @move="moveWrapper"
            :deleteAction="hasEditPermission"
            @delete="confirmDelete"
            @load="load"
          ></node>
        </div>
        <v-icon class="ma-2" v-if="i!=items.length-1">arrow_downward</v-icon>
      </div>
      <v-btn text class="primary--text" @click="onCreate" v-if="hasEditPermission">
        <v-icon small left>add</v-icon>new
      </v-btn>
    </v-sheet>
    <AFormDialog
      ref="formDialog"
      :fields="formFields"
      :modelName="'FLow Node'"
      :model="'flownodes'"
      :updateOnlyChanged="true"
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import axios from "../../api/axios";
import AFormDialog from "../../components/AFormDialog";
import ConfirmDialogMixin from "../../mixins/ConfirmDialogMixin";
import PermissionsHelper from "../../mixins/PermissionsHelper";
import crudFuncsMixin from "../../mixins/CRUDFuncs";
import node from "./components/node.vue";

export default {
  mixins: [ConfirmDialogMixin, crudFuncsMixin,PermissionsHelper],
  components: {
    AFormDialog,
    node
  },
  data() {
    return {
      model: "flownodes",
      items: [],
      contract: {}
    };
  },
  computed: {
    breadcrumbs: function() {},
    contractId: function() {
      return parseInt(this.$route.params.id);
    },
    formFields: function() {
      return [
        {
          type: "silent",
          silent: true,
          queryParam: "contractId",
          defaultValue: this.contractId
        },
        {
          type: "dropdown",
          model: "locations",
          label: "Location*",
          queryParam: "locationId",
          rules: [v => v !== undefined || "This is field is mandatory"]
        },
        {
          type: "dropdown",
          model: "states",
          label: "Status*",
          queryParam: "stateId",
          rules: [v => v !== undefined || "This is field is mandatory"]
        },
        {
          type: "checkbox",
          label: "Always use this status",
          queryParam: "forceState",
          updatable: true
        },
        {
          type: "checkbox",
          label: "Reset Car Number",
          queryParam: "resetCarNumber",
          updatable: true
        }
      ];
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    load: function() {
      if (this.contractId) {
        axios.get("/contracts/"+this.contractId).then(r => {
          if(r.data.ok){
            this.contract = r.data.d
          }
        })
        axios
          .get(
            "/flownodes?orderByColumn=listOrder&orderByDir=asc&contractId=" +
              this.contractId
          )
          .then(r => {
            if (r.data.ok) {
              this.items = r.data.d.items;
            }
          });
      }
    },
    moveWrapper(node, offset) {
      this.move(node, node.listOrder + offset);
    }
  }
};
</script>

<style scoped>
</style>